import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div class=\"nw-flag flag-icon-{{lowercase @id}}\"></div>\n{{#if @showPlaceholderName}}\n  {{@name}}\n{{/if}}")